module.exports = {"id":"208916","name":"Mohammed Al Sahlawi","rating":"73","photo":"./data/images/photos/3/208916.png","club":{"name":"Al Nassr","logo":"./data/images/clubs/AlNassr.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MohammedAlSahlawi0.json
// module id = 3067
// module chunks = 0